export const placeHolder = {
    page: 'cutout',
    subtitle: '保留图片主体内容，灵活应用于多种场景',
    image: 'https://feed-image.baidu.com/0/pic/-39533982_1357164284_-1682659209.png'
};

export const suggestImg = [{
    url: 'https://feed-image.baidu.com/0/pic/1053802979_-159521884_-690992000.png',
    prompt: '',
    width: 212,
    height: 120
}, {
    url: 'https://feed-image.baidu.com/0/pic/-731062796_-1998481293_1597528353.png',
    prompt: '',
    width: 212,
    height: 120
}, {
    url: 'https://feed-image.baidu.com/0/pic/460307876_-1274340242_1848259789.png',
    prompt: '',
    width: 212,
    height: 120
}];

export const imageFailMessage = {
    message: '部分图片抠图失败，请尝试重新生成',
    duration: 5000
};
